
/**
  * START: COUNTDOWN TIMERS ON PAGE
  */

function runCountdownTimers() {
  const currentTime = moment().tz('Australia/Brisbane');
  // console.log("currentTime: ", currentTime.format("YYYY-MM-DD hh:mm A"));
  
  const ctTimers = document.getElementsByClassName("ct-countdownTimer");
  for (let ct of ctTimers) {
    const ctDateTimeRaw = ct.getAttribute("ct-datetime");
    const ctDateTime = moment(ctDateTimeRaw).tz('Australia/Brisbane');
    
    // console.log("ctDateTime: ", ctDateTime.format("YYYY-MM-DD hh:mm A"));
    ct.getElementsByClassName("ct-dateTime")[0].textContent = ctDateTime.format("DD MMMM YYYY @ hh:mmA") + " Brisbane";
    const difference = ctDateTime.diff(currentTime, "seconds");

    if (difference > 0) {
      let seconds = difference;
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      let days = Math.floor(hours / 24);
    
      hours %= 24;
      minutes %= 60;
      seconds %= 60;
    
      ct.getElementsByClassName("ct-timeDays")[0].textContent = days;
      ct.getElementsByClassName("ct-timeHours")[0].textContent = hours;
      ct.getElementsByClassName("ct-timeMinutes")[0].textContent = minutes;
      ct.getElementsByClassName("ct-timeSeconds")[0].textContent = seconds;
    } else {
      ct.classList.add("closed");
    }
  }
}

let runCountdowns = setInterval(runCountdownTimers, 1000)

/**
  * END: COUNTDOWN TIMERS ON PAGE
  */